import { clsx } from 'clsx'
import { type FC } from 'react'

import { DialogContent, Modal } from 'base-ui'

import {
  CROSS_SELL_ADD_TO_CART_BOTTOM,
  CROSS_SELL_ADD_TO_CART_CENTER,
  CROSS_SELL_ADD_TO_CART_TOP,
} from '../../cross-sell'
import { DrawerTransition } from '../../drawer-transition'
import { useCartIntermediateContext } from '../hooks/useCartIntermediateContext'

import { CartIntermediateCrossSellSliderWidget } from './CartIntermediateCrossSellSliderWidget'
import { CartIntermediateMessage } from './CartIntermediateLabels/CartIntermediateMessage'
import { CartIntermediateTitle } from './CartIntermediateLabels/CartIntermediateTitle'
import { CartIntermediateProductWithButtonsSection } from './CartIntermediateProductWithButtonsSection/CartIntermediateProductWithButtonsSection'
import { CartIntermediateSpecialOffersContent } from './CartIntermediateSpecialOffers/CartIntermediateSpecialOffersContent'
import { CartIntermediateSpecialOffersNotification } from './CartIntermediateSpecialOffers/CartIntermediateSpecialOffersNotification'

import styles from './CartIntermediateDrawer.module.css'

export const CartIntermediateDrawer: FC = () => {
  const {
    cartIntermediateOpenableControls: { handleClose, isOpen },
    specialOffersCollapsibleControls,
  } = useCartIntermediateContext()

  return (
    <Modal
      className={clsx(
        styles['cart-intermediate-drawer'],
        'flex flex-col items-end justify-end rounded-l-2xl',
      )}
      closeAfterTransition
      data-qa-id="cartIntermediateDrawer"
      onClose={handleClose}
      open={isOpen}
    >
      <DrawerTransition
        className="mt-[120px] flex h-dvh w-full flex-col overflow-y-auto rounded-t-2xl bg-light-primary-medium outline-none tablet:mt-0 tablet:max-w-screen-tablet tablet:rounded-l-2xl tablet:rounded-tr-none"
        in={isOpen}
      >
        {specialOffersCollapsibleControls.isOpen ? (
          <CartIntermediateSpecialOffersContent />
        ) : (
          <>
            <CartIntermediateTitle handleClose={handleClose} />
            <DialogContent>
              <CartIntermediateMessage />
              <CartIntermediateSpecialOffersNotification />
              <CartIntermediateProductWithButtonsSection
                handleClose={handleClose}
              />
              <CartIntermediateCrossSellSliderWidget
                itemsPerPage={4}
                type={CROSS_SELL_ADD_TO_CART_TOP}
              />
              <CartIntermediateCrossSellSliderWidget
                itemsPerPage={4}
                type={CROSS_SELL_ADD_TO_CART_CENTER}
              />
              <CartIntermediateCrossSellSliderWidget
                itemsPerPage={4}
                type={CROSS_SELL_ADD_TO_CART_BOTTOM}
              />
            </DialogContent>
          </>
        )}
      </DrawerTransition>
    </Modal>
  )
}
